import { Controller } from "stimulus"

export default class extends Controller {
  t(key) {
    try {
      return JSON.parse(this.element.dataset.i18n)[key] || key;
    } catch (e) {
      return key;
    }
  }

  connect() {
    this.loadedMakes = new Set();
    this.initializeSelect2();
    setTimeout(() => {
      this.initializeMakeHeaders();
    }, 1000);
  }

  initializeSelect2() { 
    const makeSelect = document.getElementById('make-select');
      
    if (typeof window.jQuery !== 'undefined' && window.jQuery.fn.select2)
    {
      const $select = window.jQuery(makeSelect);
      
    // If Select2 is already initialized, destroy it first to avoid conflicts
      if ($select.data('select2'))
      {
        $select.select2('destroy');
      }

      $select.select2({
        placeholder: this.t("select_makes"),
        allowClear: true,
        closeOnSelect: false
      }).on('change', function() {
        // Change handler if needed
      });
    }
    else
    {
      // If jQuery/Select2 not ready yet, try again after a short delay
      setTimeout(() => this.initializeSelect2(), 100);
    }
  }

  initializeMakeHeaders() {
    const headers = this.element.querySelectorAll('[data-make-models-target="makeHeader"]');

    headers.forEach(header => { 
      header.addEventListener('click', () => { 
        if (event.target.tagName === 'A' || event.target.closest('a')) {
          return;
        }
        this.toggleMake(header);
      });
    });
  }

  toggleMake(header) {
    const makeId = header.dataset.makeId;
    const collapseElement = document.getElementById(`collapse-${makeId}`);

    if (!collapseElement.classList.contains('show')) { 
      if (!this.loadedMakes.has(makeId)) {
        this.loadModels(makeId);
      }
      collapseElement.classList.add('show')
      collapseElement.classList.remove('collapse')
    }
    else {
      collapseElement.classList.remove('show')
      collapseElement.classList.add('collapse')
    }
  }

  loadModels(makeId, page = 1) {
    const collapseElement = document.querySelector(`#collapse-${makeId}`);
    const cardBody = collapseElement.querySelector('.card-body');

    cardBody.innerHTML += `<div class="text-center loading-indicator"><div class="spinner-border spinner-border-sm" role="status"><span class="sr-only">${this.t('loading')}</span></div></div>`;

    fetch(`/make_models/${makeId}/fetch_models?page=${page}`, {
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    })
    .then(response => response.json())
    .then(data => {
      cardBody.querySelector('.loading-indicator').remove();
      if (!cardBody.querySelector(`#models-table-${makeId}`)) { 
        this.loadedMakes.add(makeId);
        let tableHtml = `<table id="models-table-${makeId}" class="table table-sm table-hover mb-0"><thead><tr><th>${this.t('model')}</th><th width="150">${this.t('actions')}</th></tr></thead><tbody></tbody></table>`
        cardBody.innerHTML = tableHtml
      }
      // Render models table
      if (data.models.length > 0) {
        let modelTableRows = "";
        data.models.forEach(model => {
          modelTableRows += this.setupModelTableRow(model);
        })
        cardBody.querySelector('tbody').innerHTML += modelTableRows;
        this.setupInfiniteScroll(makeId, data.next_page);
      } else {
        if (page == 1) { 
          cardBody.innerHTML = `<div class="alert alert-info mb-0">${this.t('no_models')}</div>`
        }
      }

      // Show the collapse
      const header = this.findHeaderByMakeId(makeId)
      // if (header) this.updateIcon(header, true)
    })
    .catch(error => {
      console.error('Error loading models:', error);
      modelsContainer.innerHTML = `<div class="alert alert-danger mb-0">${this.t('load_error')}</div>`
    });
  }

  setupModelTableRow(model) {
    return `
            <tr class="model-row" data-model="${model.name.toLowerCase()}">
              <td style="cursor: pointer;" onclick="window.location.href='/vehicle_models/${model.id}'">${this.escapeHtml(model.name)}</td>
              <td>
                <a href="/vehicle_models/${model.id}/edit" class="btn btn-xs btn-outline-primary me-1">${this.t('edit')}</a>
                <a href="/vehicle_models/${model.id}" class="btn btn-xs btn-outline-danger" data-method="delete" data-confirm="${this.t('confirm_delete')}">${this.t('delete')}</a>
              </td>
            </tr>
          `
  }

  setupInfiniteScroll(makeId, nextPage) {
    // Clean up existing observer if any
    this.cleanupObserver(makeId);

    if (!nextPage) return;

    const collapseElement = document.querySelector(`#collapse-${makeId}`);
    const cardBody = collapseElement.querySelector('.card-body');
    const tbody = cardBody.querySelector('tbody');
    
    if (!tbody || !collapseElement) return;

    // Create a sentinel element at the bottom to detect when scrolled into view
    const sentinel = document.createElement('tr');
    sentinel.id = `sentinel-${makeId}`;
    sentinel.className = 'infinite-scroll-sentinel';
    sentinel.innerHTML = '<td colspan="2" style="height: 1px;"></td>';
    tbody.appendChild(sentinel);

    // Use Intersection Observer for better performance
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.loadModels(makeId, nextPage);
        }
      });
    }, {
      root: null,
      rootMargin: '100px', // Start loading 100px before reaching the bottom
      threshold: 0.1
    });

    observer.observe(sentinel);
  }

  cleanupObserver(makeId) {
    let sentinel = document.getElementById(`sentinel-${makeId}`);
    if (sentinel) {
      sentinel.remove();
    }
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }

  findHeaderByMakeId(makeId) {
    return this.element.querySelector(`.make-header[data-make-id="${makeId}"]`);
  }
}